/**
 * fashionFlats — split from `data.ts`'s legacy `PACKS` array into its own
 * module (narcis file-split shape), plan `thinking/plans/2026_08_31_toile_pack_wiring.md` Track A,
 * script `generation/scripts/packs/toile_split_data.py`.
 */
import {PORTRAIT, tagline, chips, type ToilePack} from './data'

export const fashionFlatsPack: ToilePack = {
    slug: 'fashion-flats',
    category: 'fashion',
    name: 'Fashion flats',
    tagline: tagline('boards', 'garments', 'presentations'),
    chips: chips('garments', 'presentations'),
    ratio: PORTRAIT,
    readings: [
        {key: 'trench', label: 'Trench coat', subject: 'a double-breasted trench coat, sand cotton gabardine'},
        {key: 'dress', label: 'Slip dress', subject: 'a bias-cut slip dress, emerald silk satin'},
        {key: 'jacket', label: 'Denim jacket', subject: 'a cropped boxy denim jacket, raw indigo'},
    ],
    styles: [
        {key: 'flat', label: 'Technical flat', style: 'technical fashion flat sketch, unworn', palette: 'clean black line, white ground', framing: 'front view, seams indicated'},
        {key: 'worn', label: 'Editorial', style: 'editorial illustration, worn by a faceless croquis', palette: 'loose marker and ink', framing: 'white background'},
        {key: 'board', label: 'Mood board', style: 'mood-board collage, swatches and palette strip', palette: 'fabric swatches and trims', framing: 'collage board'},
    ],
    directions: ['a tailored blazer instead', 'in oxblood leather', 'with the back view too'],
}
